import React from 'react'

import { DisplayAssetProps } from '../../../types/preview'

const DisplayVideo = ({
  asset,
  height,
  openInModal,
  modalOpen,
}: DisplayAssetProps): React.ReactElement => {
  return (
    <div
      style={{
        cursor: 'pointer',
        height: modalOpen ? '90vh' : height,
      }}
    >
      <video
        onClick={() => openInModal()}
        src={asset.public_url ?? (asset.data || '')}
        style={{
          width: '100%',
          height: modalOpen ? '100%' : height,
          objectFit: modalOpen ? 'contain' : 'cover',
        }}
        autoPlay={false}
        muted
        loop
        controls
        preload="auto"
      />
    </div>
  )
}

export default DisplayVideo
